import httpClient from "@/services/httpClient";
import { server, trademark_const } from "@/services/constants";

export const getAllIP_INV = () => {
    return httpClient.get(`${trademark_const.trademark_url}/` + server.IP_INV + `/`);
};

export const CreateIP_INV = (data) => {
    return httpClient.post(`${trademark_const.trademark_url}/` + server.IP_INV, data);
};

export const updateIP_INV = (id, data) => {
    return httpClient.put(`${trademark_const.trademark_url}/` + server.IP_INV + `/${id}`, data);
};


export const DeleteIP_INV = (id) => {
    return httpClient.delete(`${trademark_const.trademark_url}/` + server.IP_INV + `/${id}`);
};
